import { render, staticRenderFns } from "./AdminPasTvarkymas.vue?vue&type=template&id=7e165cab&scoped=true&"
import script from "./AdminPasTvarkymas.vue?vue&type=script&lang=js&"
export * from "./AdminPasTvarkymas.vue?vue&type=script&lang=js&"
import style0 from "./AdminPasTvarkymas.vue?vue&type=style&index=0&id=7e165cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e165cab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VDataTable,VRow})
